import { useParams } from 'react-router-dom'
import toast from 'react-hot-toast'
import { PricingPage as SaaSPricingPage } from '@roselabs-io/saas-shell'
import { billingApi } from '../api/billing'

export default function PricingPage() {
  const { teamId } = useParams<{ teamId: string }>()

  if (!teamId) {
    return null
  }

  return (
    <SaaSPricingPage
      teamId={teamId}
      backPath={`/t/${teamId}/settings`}
      backLabel="Back to Settings"
      contactPath="/contact"
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      getPlans={() => billingApi.getTeamPlans(teamId) as any}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      getSubscription={() => billingApi.getSubscription(teamId) as any}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      getUsage={() => billingApi.getUsage(teamId) as any}
      getCheckoutUrl={planName => billingApi.getCheckoutUrl(teamId, planName)}
      getPortalUrl={() => billingApi.getPortalUrl(teamId)}
      switchPlan={async planName => {
        await billingApi.switchPlan(teamId, planName)
        return { message: `Successfully switched to ${planName} plan` }
      }}
      onToast={(message, type) => {
        if (type === 'success') toast.success(message)
        else toast.error(message)
      }}
      faqItems={[
        {
          question: 'What happens when I reach my app limit?',
          answer:
            "You'll need to remove an existing app or upgrade to a higher plan to add more apps.",
        },
        {
          question: 'Can I change my plan later?',
          answer:
            'Yes! You can upgrade or downgrade at any time. Changes take effect immediately and are prorated.',
        },
        {
          question: 'What payment methods do you accept?',
          answer:
            'We accept all major credit cards through Stripe. Enterprise customers can request invoicing.',
        },
      ]}
    />
  )
}
